module.exports = __webpack_public_path__ + "img/peter.5a640689.jpeg";